export { default } from './FaqSectionWrapper'
